import BaseApi from '@/api/Base/BaseApi'
import { HyperparametersBase } from '@/api/Hyperparameters/types'
import { HyperParameterType } from '@/pages/const'

const ROOT = '/hyperparameters'
export default class HyperparametersApi extends BaseApi {
  createHyperParameter(payload: HyperparametersBase) {
    const { projectId, ...rest } = payload
    return this.agent.post<HyperparametersBase>(`/project/${projectId}/hyperparameters/create`, rest)
  }

  deleteHyperparameters(hyperparametersId: string) {
    return this.agent.delete<HyperparametersBase>(`${ROOT}/${hyperparametersId}`)
  }

  getHyperParameterList(projectId: string, hyperparameterType: HyperParameterType) {
    return this.agent.get<HyperparametersBase[]>(`${ROOT}/list`, {
      params: { project_id: projectId, hyperparameterType },
    })
  }

  getDefaultHyperParameter(projectId: string, hyperparameterType: HyperParameterType) {
    return this.agent.get<HyperparametersBase>(`${ROOT}/${projectId}/dynamic-value`, {
      params: { hyperparameterType },
    })
  }

  updateHyperparameters(payload: HyperparametersBase) {
    const { _id: hyperparametersId } = payload
    return this.agent.put<HyperparametersBase>(`${ROOT}/${hyperparametersId}`, payload)
  }

  /** @deprecated */
  getHyperparameters(hyperparametersId: string) {
    return this.agent.get<HyperparametersBase>(`${ROOT}/${hyperparametersId}`)
  }
}
